export const company = {
  name: "LX Bouw",
  phone: "0475 69 41 55",
  phoneRaw: "+32475694155",
  email: "info@lxbouw.be",
  street: "Muylaertstraat 2",
  city: "9160 Eksaarde",
  region: "Oost-Vlaanderen, België",
};
